const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Permiso de circulación del vehículo',
	'vehicleRegistrationDocument.description':
		'Sube fotos claras de las caras solicitadas del permiso de circulación.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Anverso del permiso de circulación',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Haz una foto clara del anverso del permiso de circulación.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Anverso del permiso de circulación',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Anverso del permiso de circulación - ejemplo',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Anverso del permiso de circulación',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Reverso del permiso de circulación',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Haz una foto clara del reverso del permiso de circulación.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Reverso del permiso de circulación',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Reverso del permiso de circulación - ejemplo',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Reverso del permiso de circulación',
	'vehicleRegistrationDocument.validationHeadline': 'Faltan fotos',
	'vehicleRegistrationDocument.validationDescription': 'Añade las siguientes fotos:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Haz fotos del permiso de circulación',
	'review.stepDescription.vehicleRegistrationDocument': 'Permiso de circulación del vehículo',
	'button.accept': 'Aceptar',
	'button.addLater': 'Adicionar más adelante',
	'button.backchangeImage': 'Volver y cambiar la imagen',
	'button.changeImage': 'Cambiar la foto',
	'button.close': 'Cerrar',
	'button.continue': 'Continuar',
	'button.deleteImage': 'Eliminar la foto',
	'button.next': 'Siguiente',
	'button.ok': 'Ok',
	'button.prev': 'Atrás',
	'button.start': 'Comienzo',
	'chooseLang.headline': 'Elija su idioma preferido',
	'completeDamageImages.description':
		'Adicione al menos 2 fotos del siniestro desde diferentes distancias.',
	'completeDamageImages.headline': 'Sugerencia',
	'damageImages.photo': 'Foto del siniestro',
	'completeDashboardMileageModal.dashboardImage': 'Foto del kilometraje',
	'completeDashboardMileageModal.description': 'Kilometraje del vehículo',
	'completeDashboardMileageModal.hasValidMileage': 'Kilometraje',
	'completeDashboardMileageModal.headline': 'Sugerencia',
	'completeFourAdditionalPicturesModal.description':
		'Para continuar, por favor sube las siguientes fotos:',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Foto del kilometraje',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Foto del tablero de instrumentos',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Foto del número de bastidor/VIN',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Foto del parabrisas.',
	'completeFourAdditionalPicturesModal.headline': 'Consejo',
	'completeVehicleImagesModal.description': 'Para continuar, por favor sube las siguientes fotos:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft':
		'Foto de la parte delantera izquierda del vehículo.',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Foto de la parte delantera derecha del vehículo.',
	'completeVehicleImagesModal.hasVehicleImageRearLeft':
		'Foto de la parte trasera izquierda del vehículo',
	'completeVehicleImagesModal.hasVehicleImageRearRight':
		'Foto de la parte trasera derecha del vehículo',
	'completeVehicleImagesModal.headline': 'Sugerencia',
	'completeVehicleInformationModal.description': 'Por favor adicione la siguiente infotmación:',
	'completeVehicleInformationModal.headline': 'Sugerencia',
	'completeVehicleInformationModal.isRegistrationDocument2Uploaded':
		'Foto del permiso de circulación (reverso)',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Foto del permiso de circulación',
	'completeVinModal.description': 'Por favor, proporcione la siguiente información:',
	'completeVinModal.hasVin': 'Foto del número de VIN/bastidor',
	'completeVinModal.headline': 'Sugerencia',
	'connectionError.description': 'Error de conexión. Sube la imagen de nuevo.',
	'connectionError.title': 'Error de conexión',
	'damageImages.additionalImages': 'Imágenes adicionales del siniestro',
	'damageImages.description':
		'Tome al menos 2 fotos del siniestro desde diferentes distancias (primer plano / componente completo). Importante: Los daños deben ser visibles. A partir de las fotos, creamos el cálculo.',
	'damageImages.headline': 'Imágenes del siniestro',
	'damageImages.optionalDamageImages':
		'Opcionalmente, añada más fotos de los daños, que documenten adicionalmente el siniestro.',
	'damageImagesExampleModal.headline': 'Fotos del siniestro - Ejemplo',
	'dashboardImageExampleModal.headline': 'Foto del cuentakilómetros - ejemplo',
	'dashboardMileage.dashboard.paragraph':
		'Tome una foto del cuentakilómetros del vehículo con el kilometraje totalmente visible. Si su vehículo tiene pantallas electrónicas, enciéndalas.',
	'dashboardMileage.dashboard.title': 'Foto del kilometraje',
	'dashboardMileage.headline.first': 'Kilometraje',
	'dashboardMileage.paragraph.first': 'Introduzca el kilometraje del vehículo.',
	'dashboardMileage.placeholder': 'Por ejemplo: 15000 km',
	'dataPrivacyModal.headline': 'Iniciar',
	'editPhoto.edit': 'Cambiar',
	'feedback.button.send': 'Enviar',
	'feedback.description': ' ',
	'feedback.headline': 'Fotos recibidas con éxito!',
	'feedback.headline.policyCheck': 'Fotos recibidas con éxito!',
	'feedback.rating.policyCheck':
		'¿Con cuántas estrellas calificarías tu experiencia con la aplicación, siendo 5 la mejor puntuación?',
	'feedback.yourOpinion': 'Comentarios',
	'fourAdditionalPictures.mileage.description':
		'Por favor, tome una foto del kilometraje del vehículo. Si su vehículo tiene una pantalla digital, enciéndalo.',
	'fourAdditionalPictures.mileage.enter': 'Ingrese el kilometraje del vehículo.',
	'fourAdditionalPictures.mileage.title': 'Kilometraje',
	'fourAdditionalPictures.overallDashboard.description':
		'Fotografíe completamente el tablero de su vehículo.',
	'fourAdditionalPictures.overallDashboard.title': 'Tablero de instrumentos del vehículo',
	'fourAdditionalPictures.title': 'Fotos adicionales',
	'fourAdditionalPictures.vin.description':
		'Por favor, tome una foto del número de VIN/Bastidor de su vehículo. Puede encontrarlo en el sello de la puerta del conductor o en la esquina inferior izquierda del parabrisas.',
	'fourAdditionalPictures.vin.title': 'Número de VIN/Bastidor del vehículo',
	'fourAdditionalPictures.windshield.description':
		'Por favor, tome una foto detallada del parabrisas delantero de su vehículo.',
	'fourAdditionalPictures.windshield.title': 'Parabrisas delantero del vehículo',
	'fourAdditionalPicturesExampleModal.button.close': 'Cerrar',
	'fourAdditionalPicturesExampleModal.headline.first': 'Fotos adicionales',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Foto ilustrativa',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Foto ilustrativa',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Foto ilustrativa',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Foto ilustrativa',
	'fourDiagonalPerspectives.vehicleFrontLeft.title':
		'Foto de la parte delantera izquierda del vehículo.',
	'fourDiagonalPerspectives.vehicleFrontRight.title':
		'Foto de la parte delantera derecha del vehículo.',
	'fourDiagonalPerspectives.vehicleRearLeft.title':
		'Foto de la parte trasera izquierda del vehículo',
	'fourDiagonalPerspectives.vehicleRearRight.title':
		'Foto de la parte trasera derecha del vehículo',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Foto ilustrativa',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Foto ilustrativa',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Foto ilustrativa',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Foto ilustrativa',
	'fourPerspectivesExampleModal.button.close': 'Cerrar',
	'fourPerspectivesExampleModal.headline.first': 'Fotos de Vehículos - ejemplo',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Foto ilustrativa',
	'imageRecognitionMismatchModal.headline': '¿Estás seguro de haber subido la imagen correcta?',
	'landing.aboutPolicyCheck': '¿Qué es el PolicyCheck?',
	'landing.additional-informations-section.title':
		'Antes de iniciar la verificación de su vehículo, compruebe que:',
	'landing.additional-informations-section.text':
		'<ul>' +
		'<li>tienes las llaves y el permiso de Circulación</li>' +
		'<li>se encuentra en un lugar con buena luz y buena recepción de teléfono móvil</li>' +
		'<li>el vehículo es accesible desde todos los ángulos y las ventanas laterales están cerradas.</li>' +
		'</ul>',
	'landing.changeLang': 'Para cambiar el idioma, haz clic aquí.',
	'landing.headline': 'Estimación de reparación en pocos pasos:',
	'landing.headline.policyCheck': 'Bienvenido',
	'landing.paragraph': 'Usted está a tan solo tres pasos de terminar el proceso.',
	'landing.stepDescription.damageImages': 'Tome las fotos del siniestro',
	'landing.stepDescription.feedback': 'Denos su opinion',
	'landing.stepDescription.fourAdditionalPictures': 'Tome las fotos solicitadas',
	'landing.stepDescription.fourDiagonalPerspectives': 'Cargue las fotos',
	'landing.stepDescription.vehicleImages': 'Tome las fotos del vehículo',
	'landing.stepDescription.vehicleInformation': 'Detalles del vehículo',
	'landing.termsAndConditionsLink':
		'Por favor acepte los términos y condiciones antes de continuar.',
	'landing.termsAndConditionsLinkDescription':
		'Por favor tenga a mano la documentación de su vehículo antes de iniciar el proceso',
	'loader.error': 'El proceso no pudo ser cargado. Por favor, intenta de nuevo más tarde...',
	'loader.loading': 'Cargando datos...',
	'mainError.tryAgain': 'Intenta de nuevo',
	'overallDashboardImage.headline': 'Tablero',
	'registrationDocumentExampleModal.headline': 'Foto del permiso de circulación - Ejemplo',
	'review.editViewButton': 'Ver/Editar',
	'review.button.next': 'Siguiente',
	'review.headline.first': 'Comprobar',
	'review.paragraph.first':
		'Compruebe sus datos antes de hacer clic en <b>Finalizar</b>. Recibirá un resumen de los datos ingresados.',
	'review.stepDescription.damageImages': 'Imágenes del siniestro',
	'review.stepDescription.mileage': 'Kilometraje',
	'review.stepDescription.vehicleImages': 'Fotos generales del vehículo',
	'review.stepDescription.vehicleInformation': 'Detalles del vehículo.',
	'review.stepDescription.vinPicture': 'Foto del número de bastidor del vehículo.',
	'thanks.headline.first': 'Gracias por confiar en nosotros',
	'thanks.paragraph.first': 'Gracias por confiar en AIG',
	'timeout.bottom': ' ',
	'timeout.headline.first': 'el enlace a la aplicación ya no está disponible.',
	'tutorialModal.headline.first.policyCheck': '',
	'tutorialModal.paragraph.first.policyCheck': '',
	'tutorialModal.paragraph.second': '',
	'upload.message':
		'Sus fotos y archivos serán ahora enviados. Dependiendo de la velocidad de su conexión a internet, este proceso puede tomar varios minutos.',
	'vehicleImages.description':
		'Fotografíe su vehículo en diagonal, delante a la izquierda y a la derecha, y detrás a la izquierda y a la derecha. La matrícula debe ser visible en todas las imágenes.',
	'vehicleImages.details.frontleft':
		'Tome una foto de la diagonal delantera izquierda del vehículo completo. La matrícula debe ser legible.',
	'vehicleImages.details.rearright':
		'Tome una foto de la diagonal trasera derecha del vehículo completo, que incluya la matricula trasera completa.',
	'vehicleImages.leftFrontOverview': 'La parte delantera izquierda del vehículo.',
	'vehicleImages.leftRearOverview': 'La parte trasera izquierda del vehículo.',
	'vehicleImages.overviewPhotos': 'Fotografías del vehículo',
	'vehicleImages.overviewPhotos.subtitle': ' ',
	'vehicleImages.rightFrontOverview': 'La parte trasera derecha del vehículo.',
	'vehicleImages.rightRearOverview': 'La parte delantera derecha del vehículo',
	'vehicleImagesExampleModal.button.close': 'Cerrar',
	'vehicleImagesExampleModal.headline.first': 'Vista general del vehículo - Ejemplo',
	'vehicleInformation.headline.first': 'Detalles del Vehículo',
	'vehicleInformation.headline.fourth': 'Foto del permiso de circulación (reverso)',
	'vehicleInformation.headline.second': 'Foto del permiso de circulación (anverso)',
	'vehicleInformation.paragraph.first': 'Tome una foro del permiso de circulación (anverso)',
	'vehicleInformation.paragraph.fourth': 'Tome una foro del permiso de circulación (reverso)',
	'vinImagesExampleModal.button.close': 'Cerrar',
	'vinImagesExampleModal.headline.first': 'Foto del número de VIN/bastidor - ejemplo',
	'vinPicture.description': 'Tome una foto del número de VIN/bastidor',
	'vinPicture.headline': 'Foto del número VIN',
	'vinPicture.title': 'Foto del número de VIN/bastidor',
	'waitForAudit.description.damageFound': 'Gracias por confiar en nosotros',
	'waitForAudit.thankYou': 'Apreciamos tu opinión!',
	'windshieldImage.headline': 'Foto del parabrisas.',

	'testcasemodal.headline': '¡Advertencia de caso de prueba!',
	'testcasemodal.accept': 'Aceptar',
	'testcasemodal.paragraph': '¡Tenga en cuenta que es un caso de prueba!',
	'testcasewarningalert.paragraph': '¡Este es un caso de prueba!',
	'additionaldamagewarningalert.paragraph':
		'Nuestra IA ha detectado posibles daños, las fotografías serán revisadas por nuestros especialistas',

	'blockedByDevice.headline': 'PolicyCheck no permite el uso de navegadores de escritorio',
	'blockedByDevice.description':
		'PolicyCheck utiliza un navegador de escritorio.\r\nLa plataforma PolicyCheck realiza la documentación de casos mediante dispositivos móviles.\r\nPara continuar, ejecute el enlace PolicyCheck en un dispositivo móvil.',

	'completeFourAdditionalDocumentsModal.headline': 'Ayuda',
	'completeFourAdditionalDocumentsModal.description':
		'Por favor, adjunta la siguiente información:',
	'fourAdditionalDocuments.title': 'Detalles del vehículo',
	'fourAdditionalDocuments.RegistrationDocument.title':
		'Foto del permiso de circulación (por delante)',
	'fourAdditionalDocuments.RegistrationDocument.description':
		'Haz una foto del permiso de circulación (por delante)',
	'fourAdditionalDocuments.RegistrationDocument.exampleModalTitle':
		'Foto del permiso de circulación - ejemplo',
	'fourAdditionalDocuments.RegistrationDocument.headline':
		'Foto del permiso de circulación (por delante)',
	'fourAdditionalDocuments.RegistrationDocumentInside.title':
		'Foto del permiso de circulación (por detrás)',
	'fourAdditionalDocuments.RegistrationDocumentInside.description':
		'Haz una foto del permiso de circulación (por detrás)',
	'fourAdditionalDocuments.RegistrationDocumentInside.exampleModalTitle':
		'Foto del permiso de circulación de tu vehículo',
	'fourAdditionalDocuments.RegistrationDocumentInside.headline':
		'Foto del permiso de circulación (por detrás)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.title':
		'Foto de la ficha técnica del vehículo (por delante)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.description':
		'Haz una foto de la ficha técnica del vehículo (por delante)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.exampleModalTitle':
		'Foto de la ficha técnica del vehículo - ejemplo',
	'fourAdditionalDocuments.VehicleDatasheetOutside.headline':
		'Foto de la ficha técnica del vehículo (por delante)',
	'fourAdditionalDocuments.VehicleDatasheetInside.title':
		'Foto de la ficha técnica del vehículo (por detrás)',
	'fourAdditionalDocuments.VehicleDatasheetInside.description':
		'Haz una foto de la ficha técnica del vehículo (por detrás)',
	'fourAdditionalDocuments.VehicleDatasheetInside.exampleModalTitle':
		'Foto de la ficha técnica del vehículo',
	'fourAdditionalDocuments.VehicleDatasheetInside.headline':
		'Foto de la ficha técnica del vehículo (por detrás)',
	'fourAdditionalDocuments.ITV.title': 'Foto de ITV',
	'fourAdditionalDocuments.ITV.description': 'Haz una foto del sello de ITV en vigor',
	'fourAdditionalDocuments.ITV.exampleModalTitle': 'Foto de ITV - ejemplo',
	'fourAdditionalDocuments.ITV.headline': 'Foto de ITV',

	'image.locked.RegistrationDocument':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes del permiso de circulación.',
	'image.locked.RegistrationDocumentInside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes del permiso de circulación.',
	'image.locked.DniInside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes del DNI.',
	'image.locked.DniOutside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes del DNI.',
	'image.locked.VehicleDatasheetInside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes de la ficha técnica del vehículo.',
	'image.locked.VehicleDatasheetOutside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes de la ficha técnica del vehículo.',
	'image.locked.DriverLicenseInside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes del permiso de conducción.',
	'image.locked.DriverLicenseOutside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de imágenes del permiso de conducción.',
	'image.locked.ITV':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de la imagen de ITV.',

	'invalidFile.size.title': 'Tamaño de archivo incorrecto',
	'invalidFile.size.description': 'El tamaño de la imagen es mayor que el máximo requerido.',
	'invalidFile.extension.title': 'Este tipo de archivo no es válido',
	'invalidFile.extension.description':
		'Este tipo de archivo no es válido. Los formatos aceptados en este caso serían: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
